(function () {
  function init() {
    var prefersReduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced || typeof IntersectionObserver === "undefined") return;

    var scrollTargets = [];
    ["#Frame2", "#Frame3", "#Frame4", "#Frame5", "#Frame7"].forEach(
      function (id) {
        var content = document.querySelector(id + " .content");
        if (!content) return;
        content.classList.add("fx-rise");
        scrollTargets.push(content);
      },
    );
    var fadeContent = document.querySelector("#Frame6 .content");
    if (fadeContent) {
      fadeContent.classList.add("fx-fade");
      scrollTargets.push(fadeContent);
    }

    if (scrollTargets.length) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("active");
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0 },
      );
      scrollTargets.forEach(function (el) {
        observer.observe(el);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
